export enum SYSTEM_VERSIONS {
    W2 = 'W2',
    W4 = 'W4 LoRaWAN',
}